import React from 'react';
import { Cloud, CloudOff, Loader2 } from 'lucide-react';

const SyncStatus = ({ count }) => {
  if (count === 0) {
    return (
      <div 
        className="flex items-center gap-2 text-sm text-green-600 dark:text-green-400 p-2 bg-green-100 dark:bg-green-900/30 rounded-md border border-green-200 dark:border-green-800"
        data-testid="sync-status-synced"
      >
        <Cloud className="h-4 w-4" />
        <span>All synced</span>
      </div>
    );
  }

  return (
    <div 
      className="flex items-center gap-2 text-sm text-orange-600 dark:text-orange-400 p-2 bg-orange-100 dark:bg-orange-900/30 rounded-md border border-orange-200 dark:border-orange-800"
      data-testid="sync-status-pending"
    >
      <Loader2 className="h-4 w-4 animate-spin" />
      <span>{count} pending sync</span>
    </div>
  );
};

export default SyncStatus;
